const getters = {
    token: state => state.user.token,
    user: state => state.user.user,
    permissions: state => state.user.permissions,
    menus: state => state.user.menus,
    isSuperAdmin: state => state.user.isSuperAdmin,
    userInfo: state => state.user.user
}
export default getters